export const dashboardWidthClass = "sb-account-settings-dashboard-width";
export const modalWidthClass = "sb-account-settings-modal-width";

export const modalContainerClass = "sb-account-settings-modal-container";

export const modalLayoutClass = "sb-account-settings-modal-layout";

export const dashboardClass = "sb-account-settings-dashboard";

export const pageClasses = "sb-account-settings-page-reset-margin";

export const modalClasses = "sb-account-settings-modal-root";

export const tabTriggerClass = "sb-account-settings-tab-trigger";

export const horizontalTabClass = "sb-account-settings-horizontal-tab-list";

export const verticalTabClass = "sb-account-settings-vertical-tab-list";
